<template>
    <div class="container mx-auto max-w-2xl">
        <h1 class="text-2xl text-grey-darkest font-semibold mb-6">
            Properties to rent in {{ category }} ({{ regions.name }})
        </h1>

        <grid-layout>
            <grid-layout-item
                v-for="(region, index) in regions.children"
                :key="index"
                class="mb-6"
            >
                <h6 class="font-semibold text-grey-darkest text-lg mb-3">
                    {{ region.name }}
                </h6>

                <grid-layout>
                    <grid-layout-item
                        v-for="(value, key) in region.children"
                        :key="key"
                        class="w-1/4 mt-1"
                    >
                        <router-link
                            :to="{
                                name: 'listings.in.index',
                                params: {
                                    location: key
                                }
                            }"
                            class="text-grey-darker"
                        >
                            {{ value }}
                        </router-link>
                    </grid-layout-item>
                </grid-layout>
            </grid-layout-item>
        </grid-layout>
    </div>
</template>

<script>
    import _ from 'lodash'
    import HeadMixin from '../../../mixins/head'

    export default {
        mixins: [
            HeadMixin
        ],
        computed: {
            category () {
                return _.preload(`regions.${this.$route.params.category}.name`)
            },
            regions () {
                return _.preload(`regions.${this.$route.params.category}.children.${this.$route.params.subcategory}`)
            }
        },
        methods: {
            head () {
                return {
                    title: [
                        `Properties to rent in ${this.category} (${this.regions.name})`,
                        'UK houses and flats to rent'
                    ]
                }
            }
        }
    }
</script>
